import { AlertIcon } from '@approvalmax/ui';
import { Alert, Box, Flex, Spacing, StatusLabel, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from './DecisionMadeSection.messages';
import { DecisionMadeSectionProps } from './DecisionMadeSection.types';

export const DecisionMadeSection = memo<DecisionMadeSectionProps>((props) => {
    const { quote } = props;

    const { decisionMaker, isAccepted } = quote;

    return (
        <>
            {decisionMaker ? (
                <Flex direction='column'>
                    <Flex direction='column' spacing='8'>
                        <Text
                            font='headline'
                            fontSize='xsmall'
                            as='h4'
                        >{`${decisionMaker.firstName} ${decisionMaker.lastName}`}</Text>

                        <Text font='label' color='midnight70'>
                            {decisionMaker.company}
                        </Text>
                    </Flex>

                    <Text font='label' fontWeight='medium' color='midnight70'>
                        {decisionMaker.title}
                    </Text>
                </Flex>
            ) : (
                <Alert color='midnight20' startIcon={<AlertIcon />}>
                    {messages.notificationText}
                </Alert>
            )}

            <Spacing height={16} />

            <StatusLabel color={isAccepted ? 'green100' : 'red100'} size='large'>
                {isAccepted ? messages.acceptedStatusText : messages.rejectedStatusText}
            </StatusLabel>

            {decisionMaker && (
                <>
                    <Spacing height={40} />

                    <Flex direction='column' spacing='8'>
                        <Text font='label' color='midnight70'>
                            {messages.commentSectionTitle}
                        </Text>

                        <Box color='silver80' radius='small' spacing='16' width='100%'>
                            {decisionMaker.comment}
                        </Box>
                    </Flex>
                </>
            )}
        </>
    );
});

DecisionMadeSection.displayName = 'DecisionMadeSection';
